
import { Swiper, SwiperSlide } from 'swiper/react';// 引入需要的模块
import { Navigation, Autoplay } from 'swiper/modules';
import { Header } from './Header';
import { Cover } from './Cover';
import { Content } from './Content';
import { Tools } from './Tools';
import { usePageScroll } from './usePageScroll';
import { Footer } from '../../components/Footer';
import './home.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useEffect, useRef } from 'react';
function Home() {
  const { topHeight } = usePageScroll({ pageCount: 2, lastPageOffset: 120 });
  // 1. 创建 ref 指向自定义按钮
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const swiperRef = useRef<any>(null);
  useEffect(() => {
  if (
    swiperRef.current &&
    prevButtonRef.current &&
    nextButtonRef.current
  ) {
    swiperRef.current.params.navigation.prevEl = prevButtonRef.current;
    swiperRef.current.params.navigation.nextEl = nextButtonRef.current;

    swiperRef.current.navigation.init();
    swiperRef.current.navigation.update();
  }
}, []);
  // 幻灯片数据数组
  const slidesData = [
    {
      imgSrc: '/image/screen1.png',
      title: '潮盒启封，惊喜无限',
      text: '每一次开箱，都遇见不一样的潮流好物',
      width: '15.69rem',
      height: '33.88rem',
    },
    {
      title: '盲趣无限，潮玩由我',
      text: '解锁未知惊喜，收藏属于你的潮流态度',
      tools: true,
    },
    {
      imgSrc: '/image/screen3.png',
      title: '一拆倾心，潮品自来',
      text: '指尖轻启盲盒，潮流好物即刻拥有',
      width: '36.464999999999996rem',
      height: '35.535000000000004rem',
    },
    {
      imgSrc: '/image/screen4.png',
      title: '盲盒奇遇，潮力全开',
      text: '不定义风格，拆出属于你的专属潮流惊喜',
      width: '31.81rem',
      height: '31.81rem',
    },
  ];
  return (
    <div className="main">
      <div
        className="wrapper"
        style={{
          transform: `translate3d(0px, ${-topHeight}px, 0px)`,
          transitionDuration: '0.8s',
          transitionDelay: '0ms',
        }}
      ><Header />
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          speed={900}
         navigation={{
  prevEl: prevButtonRef.current,
  nextEl: nextButtonRef.current,
}}
          onBeforeInit={(swiper: any) => {
            if (typeof swiper.params.navigation !== 'boolean') {
              swiper.params.navigation.prevEl = prevButtonRef.current;
              swiper.params.navigation.nextEl = nextButtonRef.current;
            }
          }}
          autoplay={{
            delay: 10000,           // 10秒切换
            disableOnInteraction: true, // 用户操作后是否停止自动播放，true 表示继续 
          }}
          onSwiper={(swiper: any) => {
            // if (prevButtonRef.current && nextButtonRef.current) {
            //   // 确保 navigation 参数存在且为对象
            //   if (swiper.params.navigation && typeof swiper.params.navigation === 'object') {
            //     swiper.params.navigation.prevEl = prevButtonRef.current;
            //     swiper.params.navigation.nextEl = nextButtonRef.current;
            //     // 重新初始化导航模块
            //     swiper.navigation.init();
            //     swiper.navigation.update();
            //   }
            // }
             swiperRef.current = swiper;
          }}
        >
          {slidesData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="page" style={{ backgroundImage: `url(/image/background.png)` }}>

                <div className="wrap" style={{ ['--cover-width' as any]: slide.width, ['--cover-height' as any]: slide.height }}>
                  <Cover >
                    {slide.imgSrc && <img src={slide.imgSrc} />}
                  </Cover>
                  <Content title={slide.title} text={slide.text} />
                </div>
                {slide.tools && <div className="person">
                  <img src="/image/person.png" />
                </div>}
                {slide.tools && <Tools />}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-navigation">
          <button ref={prevButtonRef} className="custom-prev">
            <img src="/image/arrow-left.png" />
          </button>
          <button ref={nextButtonRef} className="custom-next">
            <img src="/image/arrow-right.png" />
          </button>
        </div>


        {/* 底部 */}
        <Footer />
      </div>
    </div>
  );
}

export default Home;
